import { render, staticRenderFns } from "./RuoliCompletati.vue?vue&type=template&id=c9e4bac2&scoped=true&"
import script from "./RuoliCompletati.vue?vue&type=script&lang=js&"
export * from "./RuoliCompletati.vue?vue&type=script&lang=js&"
import style0 from "./RuoliCompletati.vue?vue&type=style&index=0&id=c9e4bac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e4bac2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9e4bac2')) {
      api.createRecord('c9e4bac2', component.options)
    } else {
      api.reload('c9e4bac2', component.options)
    }
    module.hot.accept("./RuoliCompletati.vue?vue&type=template&id=c9e4bac2&scoped=true&", function () {
      api.rerender('c9e4bac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RuoliCompletati.vue"
export default component.exports